/**
   * Trạng thái quyết định giao
   */
export default {
  InUse: 1, // còn hiệu lực
  Return: 2 // đã thu hồi
};